// src/components/AssignmentCard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Clock } from "lucide-react";

const statusColors = {
  pending: "text-yellow-500 bg-yellow-100",
  completed: "text-green-600 bg-green-100",
  reviewed: "text-blue-600 bg-blue-100",
};

const AssignmentCard = ({ assignment }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/dashboard/student/assignment/${assignment._id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 flex justify-between items-start 
      hover:shadow-lg hover:scale-[1.01] transition-all duration-200 cursor-pointer"
    >
      <div className="flex items-start space-x-3">
        <div className="p-2 bg-gray-100 rounded-lg">
          <FileText className="text-gray-500" size={22} />
        </div>
        <div>
          <h4 className="font-semibold text-gray-800 capitalize">
            {assignment.type.replace("_", " ")}
          </h4>
          {/* <p className="text-gray-500 text-sm mt-1 line-clamp-2">
            {assignment.summary || "No summary available"}
          </p> */}
          <p className="text-xs text-gray-400 mt-1 flex items-center">
            <Clock className="w-3 h-3 mr-1" />{" "}
            {new Date(assignment.createdAt).toLocaleString("en-IN", {
              dateStyle: "medium",
              timeStyle: "short",
            })}
          </p>
        </div>
      </div>

      <span
        className={`px-3 py-1 text-xs rounded-full font-medium capitalize ${
          statusColors[assignment.status] || "bg-gray-100 text-gray-600"
        }`}
      >
        {assignment.status}
      </span>
    </div>
  );
};

export default AssignmentCard;
